export default {
    pgyerApiUrl: process.env.NODE_ENV === 'development' ? 'http://sxtest.yesno.com.cn/gdwx/api' : '/gdwx/api',
    // pgyerApiUrl: process.env.NODE_ENV === 'development' ? 'https://pts.panasonic.cn/gdwx/api' : '/gdwx/api',
    isShowLoading: true
}